import { LookupItemVm } from './lookupItem';
import { ApiResponseBase } from './apiResponse';
export class BlogShortVm {
    id: number;
    title: string;
    isActive: boolean;
}

export class BlogVm extends BlogShortVm {
    author: string;
    subtitle: string;
    introduction: string;
    body: string;
    thumbnailImage: string;
    displayOrder: number;
    createDate: Date;
    isFeatured: boolean;
    topics: BlogTopicVm[];
}

export class BlogTopicVm extends LookupItemVm {
}

export class BlogSaveResponse extends ApiResponseBase {
    blog: BlogVm;
}